<script type="text/ecmascript-6">
    import DesignerQuestionFrameColourInternal from "../DesignerQuestionFrameColourInternal.vue";

    export default {
        mixins: [
            DesignerQuestionFrameColourInternal
        ],
        computed: {
            passed_filter(){
                return this.variable_ready(this.frameColourExternal, this.slab) && (this.frameMaterial === '' || this.variable_ready(this.frameMaterial, this.slab));
            },
        },
        mounted() {
            window.emitter.on('frame-external-colour-updated', (new_colour) => {
                if(this.fabricator === 3 && this.frameMaterial === 2){
                    this.localTarget = new_colour;
                }
            });
        },
        onUnmounted() {
            window.emitter.off('frame-external-colour-updated');
        },
    }
</script>
